
export default {
  name: 'icon-arrow-long',
};
